import React from "react";
import { Link } from "react-router-dom";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import "./UpgradePrompt.scss";

interface UpgradePromptProps {
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
  icon?: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  title,
  description,
  buttonText = "Upgrade now",
  buttonLink = "/settings/subscription",
  icon = "icon-pro-plan",
}) => {
  return (
    <div className="upgrade-prompt">
      <div className="upgrade-prompt-icon">
        <SvgIcon icon="icon-starter-plan" />
      </div>
      <h3 className="upgrade-prompt-title">{title}</h3>
      <p className="upgrade-prompt-description">{description}</p>
      <Link to={buttonLink} className="upgrade-prompt-button">
        {buttonText}
      </Link>
    </div>
  );
};
